import React, { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { auth, db, firestore } from '../firebaseConfig'; // firestore buraya eklendi
import { createUserWithEmailAndPassword, sendEmailVerification } from 'firebase/auth';
import { ref, set } from 'firebase/database'; // Mevcut RTDB yapınız
import { collection, addDoc } from 'firebase/firestore'; // Yeni Firestore yapınız
import CryptoJS from 'crypto-js';

export default function Register() {
    const [fullName, setFullName] = useState('');
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [confirmPassword, setConfirmPassword] = useState('');
    const [termsAccepted, setTermsAccepted] = useState(false);
    const [showModal, setShowModal] = useState(false);
    const [loading, setLoading] = useState(false);
    const navigate = useNavigate();

    // Şifre Çözücü aracınızla tam uyumlu anahtar
    const SECRET_KEY = "VetHelper_Esen_2026";

    const termsText = `KULLANIM KOŞULLARI VE GİZLİLİK POLİTİKASI

Bu Uygulamanın kullanımı, Sahip ile diğer ilişkili sözleşmeler veya yasal ilişkiler, yasal bağlayıcılıkla belirlenir. Büyük harflerle yazılmış kelimeler, bu belgenin ilgili bölümünde tanımlanmıştır. Kullanıcı, bu belgeyi dikkatlice okumalıdır.

Bu Uygulama şunlar tarafından sağlanmaktadır:
İletişim e-posta: bivetesor@gmail.com

1. KULLANIM ŞARTLARI
Aksi belirtilmedikçe, bu bölümdeki kullanım şartları genel olarak bu Uygulamanın kullanımı sırasında geçerlidir. Belirli senaryolarda, özel kullanım veya erişim şartları uygulanabilir ve bu durumlar, bu belgede ayrıca belirtilmiştir. Bu Uygulamayı kullanarak, Kullanıcılar aşağıdaki gereksinimleri karşıladıklarını teyit ederler.

2. BU UYGULAMADAKİ İÇERİK
Aksi belirtilmedikçe veya açıkça belirtilmedikçe, bu Uygulamada bulunan tüm içerik, Sahip veya lisansörleri tarafından sağlanmış veya sahip olunmaktadır. Sahip, bu Uygulamada sunulan içeriğin geçerli yasal düzenlemelere veya üçüncü taraf haklarına zarar vermemesi için en büyük çabayı göstermektedir. Ancak, bu sonuca her zaman ulaşmak mümkün olmayabilir. Bu tür durumlarda, Kullanıcıların haklarını zorunlu kılma hakkı saklı kalmak kaydıyla, ilgili şikayetleri bu belgede verilen iletişim bilgileri aracılığıyla bildirmeleri rica edilir.

3. DIŞ KAYNAKLARA ERİŞİM
Bu Uygulama aracılığıyla, Kullanıcılar üçüncü taraflar tarafından sağlanan dış kaynaklara erişebilir. Kullanıcılar, Sahip'in bu kaynaklar üzerinde hiçbir kontrolü olmadığını ve dolayısıyla içeriklerinden ve erişilebilirliklerinden sorumlu olmadığını kabul eder. Üçüncü taraflar tarafından sağlanan herhangi bir kaynağa ilişkin geçerli şartlar, içerik haklarının verilmesi de dahil olmak üzere, her bir üçüncü tarafın şartları veya bunlar yoksa geçerli yasal düzenlemelerle belirlenir.

4. KABUL EDİLEBİLEN KULLANIM
Bu Uygulama ve Hizmet yalnızca sağlandığı kapsamda, bu Şartlar ve geçerli yasalar uyarınca kullanılabilir. Kullanıcılar, bu Uygulamanın ve/veya Hizmetin kullanımının herhangi bir geçerli yasa, düzenleme veya üçüncü taraf haklarını ihlal etmemesini sağlamaktan yalnızca kendileri sorumludur.

5. GENEL HÜKÜMLER VE FERAGAT
Sahip'in bu Şartlar uyarınca herhangi bir hak veya hükmü ileri sürmemesi, herhangi bir hak veya hükmün feragat edilmesi anlamına gelmez. Hiçbir feragat, o terimin veya başka bir terimin devam eden bir feragati olarak kabul edilmez.

6. HİZMET KESİNTİSİ
En iyi hizmet düzeyini sağlamak için, Sahip, Hizmeti bakım, sistem güncellemeleri veya diğer değişiklikler için kesintiye uğratma hakkını saklı tutar ve Kullanıcıları uygun şekilde bilgilendirir. Yasa sınırları içinde, Sahip ayrıca Hizmeti tamamen askıya alma veya durdurma kararı alabilir. Hizmet durdurulursa, Sahip, Kullanıcıların Kişisel Verilerini veya bilgilerini çekmelerine yardımcı olacak şekilde işbirliği yapacak ve Kullanıcıların devam eden ürün kullanımı ve/veya tazminat haklarına saygı gösterecektir.

7. HİZMETİN Yeniden SATIŞI
Kullanıcılar, Sahip'in açık yazılı izni olmadan, doğrudan veya yasal bir yeniden satış programı aracılığıyla, bu Uygulamanın ve Hizmetin herhangi bir kısmını çoğaltamaz, kopyalayamaz, satamaz, yeniden satamaz veya bunlardan yararlanamaz.

8. FİKRİ MÜLKİYET HAKLARI
Bu Şartların herhangi bir maddesine zarar vermeksizin, bu Uygulama ile ilgili tüm fikri mülkiyet hakları (telif hakları, marka hakları, patent hakları ve tasarım hakları gibi), Sahip'in veya lisansörlerinin münhasır mülkiyetindedir ve geçerli yasalar veya fikri mülkiyetle ilgili uluslararası anlaşmalar tarafından sağlanan korumaya tabidir. Bu Uygulama ile ilgili olarak yer alan tüm ticari markalar, ticaret unvanları, hizmet markaları, kelime markaları, illüstrasyonlar, resimler veya logolar, Sahip'in mülkiyetindedir.

9. ŞARTLARIN DEĞİŞTİRİLMESİ
Sahip, bu Şartları herhangi bir zamanda değiştirme veya başka bir şekilde modifiye etme hakkını saklı tutar. Böyle bir durumda, Sahip, Kullanıcıyı bu değişiklikler hakkında uygun şekilde bilgilendirecektir. Bu değişiklikler yalnızca Kullanıcı ile olan ilişkiyi, Kullanıcılara bildirilen tarihten itibaren etkileyecektir. Hizmetin devam eden kullanımı, Kullanıcının gözden geçirilmiş Şartları kabul ettiğini gösterecektir.

10. SÖZLEŞMENİN DEVRİ
Sahip, bu Şartlar uyarınca herhangi bir veya tüm haklarını veya yükümlülüklerini devretme, atama, yenileme yoluyla devretme veya taşeronluk yapma hakkını saklı tutar. Kullanıcılar, Sahip'in yazılı izni olmadan bu Şartlar uyarınca haklarını veya yükümlülüklerini hiçbir şekilde devredemez veya aktaramaz.

11. İLETİŞİM
Bu Uygulamanın kullanımıyla ilgili tüm iletişimler, bu belgede belirtilen iletişim bilgileri kullanılarak yapılmalıdır.

12. GEÇERLİLİK
Bu Şartların bir kısmı geçersizse veya geçersiz olduğuna karar verilirse, geri kalan kısmı geçerli kalacaktır ve geçersizlik, geçerli yasaların izlediği kurallara göre yönetilecektir.`;

    const handleRegister = async (e) => {
        e.preventDefault();

        if (!termsAccepted) { alert("Lütfen kullanıcı sözleşmesini okuyup onaylayınız."); return; }
        if (password !== confirmPassword) { alert("Şifreler uyuşmuyor."); return; }
        if (password.length < 6) { alert("Şifre en az 6 karakter olmalı."); return; }

        setLoading(true);

        try {
            // 1. Firebase Auth ile Kullanıcı Oluştur
            const userCredential = await createUserWithEmailAndPassword(auth, email, password);
            const user = userCredential.user;

            // 2. Şifreyi Kriptola (Local Tool ile uyumlu)
            const encryptedPassword = CryptoJS.AES.encrypt(password, SECRET_KEY).toString();

            // 3. Doğrulama Maili Gönder
            await sendEmailVerification(user);

            // 4. Tarih Hesaplama
            const expiryDate = new Date();
            expiryDate.setDate(expiryDate.getDate() + 10);
            const expiryStr = expiryDate.toISOString().split('T')[0]; 

            // 5. MEVCUT ÇALIŞAN KOD (Realtime Database - users)
            await set(ref(db, 'users/' + user.uid), {
                adSoyad: fullName,
                email: email,
                "Kalan Kullanım Sayısı": 10,
                subscription_expiry: expiryStr,
                subscription_status: "active"
            });

            // 6. YENİ EKLEME (Firestore - history3 koleksiyonu)
            await addDoc(collection(firestore, 'history3'), {
                uid: user.uid,
                email: email,
                password_encrypted: encryptedPassword, // Kriptolu şifre
                created_at: new Date().toISOString()
            });

            alert("Kayıt Başarılı! Lütfen e-posta adresinize gelen linki onaylayın.");
            navigate('/login');

        } catch (error) {
            alert("Hata: " + error.message);
        } finally {
            setLoading(false);
        }
    };

    return (
        <div style={containerStyle}>
            <div style={cardStyle}>
                <h2>Kayıt Ol</h2>
                <form onSubmit={handleRegister}>
                    <input style={inputStyle} type="text" value={fullName} onChange={e=>setFullName(e.target.value)} placeholder="Ad Soyad" required />
                    <input style={inputStyle} type="email" value={email} onChange={e=>setEmail(e.target.value)} placeholder="Email" required />
                    <input style={inputStyle} type="password" value={password} onChange={e=>setPassword(e.target.value)} placeholder="Şifre" required />
                    <input style={inputStyle} type="password" value={confirmPassword} onChange={e=>setConfirmPassword(e.target.value)} placeholder="Şifre Tekrar" required />
                    
                    <div style={{margin: '15px 0', textAlign: 'left', display:'flex', alignItems:'center'}}>
                        <input type="checkbox" checked={termsAccepted} onChange={e=>setTermsAccepted(e.target.checked)} id="terms"/> 
                        <label htmlFor="terms" style={{fontSize: '13px', marginLeft:'5px'}}>
                            <span onClick={() => setShowModal(true)} style={{color: '#3498db', cursor: 'pointer', fontWeight:'bold', textDecoration:'underline'}}>Kullanıcı Sözleşmesini</span> okudum, onaylıyorum.
                        </label>
                    </div>

                    <button style={btnStyle} type="submit" disabled={loading}>{loading ? "İşleniyor..." : "Kayıt Ol"}</button>
                </form>
                <div style={{marginTop:'15px'}}>
                     <Link to="/login" style={{color:'#2c3e50', textDecoration:'none', fontSize:'13px'}}>Zaten üye misin? <b>Giriş Yap</b></Link>
                </div>
            </div>

            {showModal && (
                <div style={modalOverlay}>
                    <div style={modalContent}>
                        <h3>Şartlar ve Koşullar</h3>
                        <div style={modalText}>{termsText}</div>
                        <button onClick={() => setShowModal(false)} style={modalBtn}>Kapat</button>
                    </div>
                </div>
            )}
        </div>
    );
}

// --- STİLLER (Mobil ve iOS Safe-Area Uyumlu) ---
const containerStyle = { 
    display: 'flex', 
    justifyContent: 'center', 
    alignItems: 'center', 
    minHeight: '100vh', 
    background: '#ecf0f1', 
    padding: '20px',
    boxSizing: 'border-box',
    width: '100%',
    paddingTop: 'max(20px, env(safe-area-inset-top))', // iOS Çentik Koruması
    paddingBottom: 'env(safe-area-inset-bottom)'       // iOS Alt Bar Koruması
};

const cardStyle = { 
    background: 'white', 
    padding: '30px 20px', 
    borderRadius: '15px', 
    boxShadow: '0 10px 25px rgba(0,0,0,0.1)', 
    width: '100%', 
    maxWidth: '380px', 
    textAlign: 'center',
    boxSizing: 'border-box'
};

const inputStyle = { 
    width: '100%', 
    padding: '12px', 
    margin: '8px 0', 
    borderRadius: '8px', 
    border: '1px solid #bdc3c7', 
    boxSizing: 'border-box',
    fontSize: '16px', // iOS Safari zoom engellemek için kritik
    outline: 'none',
    WebkitAppearance: 'none'
};

const btnStyle = { 
    width: '100%', 
    padding: '12px', 
    backgroundColor: '#2c3e50', 
    color: 'white', 
    border: 'none', 
    borderRadius: '8px', 
    cursor: 'pointer', 
    marginTop: '10px', 
    fontWeight:'bold',
    boxSizing: 'border-box',
    WebkitTapHighlightColor: 'transparent'
};

const modalOverlay = { position: 'fixed', top: 0, left: 0, right: 0, bottom: 0, background: 'rgba(0,0,0,0.7)', display: 'flex', justifyContent: 'center', alignItems: 'center', zIndex: 1000, boxSizing: 'border-box', padding: '15px' };
const modalContent = { background: '#fff', padding: '20px', borderRadius: '10px', width: '100%', maxWidth: '500px', maxHeight: '80vh', display:'flex', flexDirection:'column', boxSizing: 'border-box' };
const modalText = { overflowY: 'auto', textAlign: 'left', margin: '15px 0', fontSize: '13px', whiteSpace: 'pre-wrap', flex: 1, boxSizing: 'border-box' };
const modalBtn = { padding: '10px', background: '#c0392b', color: '#fff', border: 'none', borderRadius: '5px', cursor: 'pointer', fontWeight: 'bold', WebkitTapHighlightColor: 'transparent' };